__turbopack_context__.v({
  "ArticleContent": "ZnhX5a_ArticleContent",
  "ArticleTopBar": "ZnhX5a_ArticleTopBar",
  "ArticleTopBarLeft": "ZnhX5a_ArticleTopBarLeft",
  "ArticleTopBarRight": "ZnhX5a_ArticleTopBarRight",
  "Authors": "ZnhX5a_Authors",
  "Byline": "ZnhX5a_Byline",
  "Container": "ZnhX5a_Container",
  "Content": "ZnhX5a_Content",
  "Dates": "ZnhX5a_Dates",
  "Divider": "ZnhX5a_Divider",
  "Heading": "ZnhX5a_Heading",
  "Label": "ZnhX5a_Label",
  "LayoutWrapper": "ZnhX5a_LayoutWrapper",
  "Left": "ZnhX5a_Left",
  "Main": "ZnhX5a_Main",
  "MapWrapper": "ZnhX5a_MapWrapper",
  "PdfPreviews": "ZnhX5a_PdfPreviews",
  "Preamble": "ZnhX5a_Preamble",
  "RelatedFiles": "ZnhX5a_RelatedFiles",
  "Right": "ZnhX5a_Right",
  "Root": "ZnhX5a_Root",
  "TableOfContents": "ZnhX5a_TableOfContents",
  "TableOfContents--Desktop": "ZnhX5a_TableOfContents--Desktop",
  "TableOfContents--Mobile": "ZnhX5a_TableOfContents--Mobile",
  "Text": "ZnhX5a_Text",
  "Title": "ZnhX5a_Title",
  "TopWrapper": "ZnhX5a_TopWrapper",
  "Updated": "ZnhX5a_Updated",
  "skeleton-loading": "ZnhX5a_skeleton-loading",
});
